











































import Vue, { PropType } from "vue";
import { Price as VcPrice } from "@/components";

interface ItemDetail {
  currencyCodeForDisplay: string;
  currencyCode: string;
  amount: number;
  purchaseUrl: string;
}

export interface PurchaseGoldChargeCodeItemProps {
  goldAmountForDisplay: string;
  itemDetails: ItemDetail[];
  showSelectCurrency: boolean;
  lang: any;
}

export default Vue.extend({
  name: "vc-purchase-gold-charge-code-item",
  components: { VcPrice },
  props: {
    goldAmountForDisplay: {
      type: String as PropType<
        PurchaseGoldChargeCodeItemProps["goldAmountForDisplay"]
      >,
      default: ""
    },
    itemDetails: {
      type: Array as PropType<PurchaseGoldChargeCodeItemProps["itemDetails"]>,
      default: () => []
    },
    showSelectCurrency: {
      type: Boolean as PropType<
        PurchaseGoldChargeCodeItemProps["showSelectCurrency"]
      >,
      default: true
    },
    lang: {
      type: Object as PropType<PurchaseGoldChargeCodeItemProps["lang"]>,
      default: () => {}
    }
  },
  data() {
    return {
      selectedCurrencyCode: "",
      amount: null as number | null,
      purchaseUrl: ""
    };
  },
  mounted() {
    const firstItem = this.itemDetails[0];
    this.selectedCurrencyCode = firstItem.currencyCode;
    this.amount = firstItem.amount;
    this.purchaseUrl = firstItem.purchaseUrl;
  },
  methods: {
    handleCurrencyChange() {
      const selectedItem = this.itemDetails.find(
        (item: ItemDetail) => item.currencyCode === this.selectedCurrencyCode
      );
      if (selectedItem) {
        this.amount = selectedItem.amount;
        this.purchaseUrl = selectedItem.purchaseUrl;
      }
    }
  }
});
